import { render, staticRenderFns } from "./PNAuto.vue?vue&type=template&id=84969280&scoped=true&"
import script from "./PNAuto.vue?vue&type=script&lang=js&"
export * from "./PNAuto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84969280",
  null
  
)

export default component.exports